module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.0f5cc8c0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Thin.ttf
// module id = 551
// module chunks = 0